export default __webpack_public_path__ + "static/media/usability-feature.64da7dae.png";